import React from 'react'
import { LuTriangleAlert } from 'react-icons/lu'

import { Alert, AlertDescription } from '@/components/ui/alert'
import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import { REFERRALS_IMPORT_STEP } from '@/lib/constants'
import {
  selectReferralsImportHistorical,
  setStep,
} from '@/redux/slices/referralsImportHistorical'

const ContinueReferralsImportMessage: React.FC = () => {
  const referralsImportHistoricalState = useAppSelector(
    selectReferralsImportHistorical,
  )
  const dispatch = useAppDispatch()

  return (
    <Alert variant="warning" className="mb-4">
      <LuTriangleAlert className="text-warning! mt-1" />
      <AlertDescription>
        <p className="mb-0">
          You have{' '}
          {referralsImportHistoricalState.importItems.length == 1
            ? '1 referral'
            : `${referralsImportHistoricalState.importItems.length} referrals`}{' '}
          in progress.{' '}
          <a
            href="#"
            onClick={() =>
              dispatch(setStep(REFERRALS_IMPORT_STEP.resolveImport))
            }
          >
            Continue
          </a>{' '}
          or upload a new file below to start over.
        </p>
      </AlertDescription>
    </Alert>
  )
}

export default ContinueReferralsImportMessage
